export const formatDate = (isoString) => {
  if (!isoString) return '—'

  const date = new Date(isoString)

  const formatter = new Intl.DateTimeFormat('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Ho_Chi_Minh'
  })

  return formatter.format(date)
}

export const formatDateNoTime = (input) => {
  if (!input) return ''

  const s = String(input).trim()
  let date
  if (/^\d{8}$/.test(s)) {
    date = new Date(`${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}T00:00:00`)
  } else {
    date = new Date(s)
  }

  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Asia/Ho_Chi_Minh'
  }).format(date)
}
